import { Button } from 'opensolar-ui'
import { openListBulkEditSessionIfValid } from 'ducks/listBulkEdit'
import React, { useMemo } from 'react'
import { useTranslate } from 'react-admin'
import { useDispatch } from 'react-redux'

import { getBulkEditDefinition } from './bulkEditRegistry'
import { mergeBulkEditToolbarDefaults } from './helpers'

type Props = {
  selectedIds: number[]
  resource: string
  filterValues?: Record<string, unknown>
  disabled?: boolean
}

export const BulkEditListToolbarButton: React.FC<Props> = ({
  selectedIds,
  resource,
  filterValues,
  disabled = false,
}) => {
  const translate = useTranslate()
  const dispatch = useDispatch()
  const definition = useMemo(() => getBulkEditDefinition(resource), [resource])
  const toolbarListDefaults = useMemo(
    () => (definition ? mergeBulkEditToolbarDefaults(definition.bulkEditToolbarListDefaults) : null),
    [definition]
  )

  if (!definition || !toolbarListDefaults) {
    return null
  }

  return (
    <Button
      variant="outlined"
      disabled={disabled}
      onClick={() => {
        if (selectedIds.length > 0) {
          openListBulkEditSessionIfValid(
            dispatch,
            {
              resource,
              selectedIds,
              initialValues: {},
            },
            definition,
            resource
          )
          return
        }
        openListBulkEditSessionIfValid(
          dispatch,
          {
            resource,
            listQuery: {
              filter: { ...(filterValues ?? {}) },
              ...toolbarListDefaults,
            },
            initialValues: {},
          },
          definition,
          resource
        )
      }}
    >
      {translate('Bulk edit')}
    </Button>
  )
}
